import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreIcon, RemarksIcon, DeleteIcon, PinBorderIcon, PinIcon, UnPinIcon } from '../../../../components/Icon';
import Dialog from '../../../../components/Dialog';
import { i18n } from '../../../../language';
import { onKeyUpEnterOrSpace } from '../../../../utils';
import Edit from './edit';

const useStyles = makeStyles((theme) => ({
  root: (type) => ({
    width: '100%',
    height: 'auto',
    minHeight: '3.75rem',
    padding: '1rem 1.25rem 1rem 1.938rem',
    marginBottom: '0.625rem',
    backgroundColor: '#f5faff',
    borderRadius: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.22rem',
      height: '100%',
      backgroundColor: type === 2 ? theme.palette.primary.main : theme.palette.font.main,
      zIndex: '9',
    },
  }),
  text: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    width: '90%',
    wordWrap: 'break-word',
  },
  button: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '0',
    '&:hover': {
      backgroundColor: '#f5faff',
    },
  },
  icon: {
    fontSize: '1.125rem',
    color: '#C0C6CB',
  },
  menu: {
    boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    borderRadius: '0.16875rem',
    margin: '0 0 0 -6rem',
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  menuitem: {
    padding: '1rem',
    height: '3.75rem',
    width: '13.313rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  menuitemText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginLeft: '1rem',
  },
  menuitemIcon: {
    fontSize: '1.25rem',
    color: theme.palette.font.main,
  },
  dialogText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginTop: '0.8rem',
  },
  pinIconBody: {
    width: '1.564rem',
    height: '1.564rem',
    marginRight: '0.938rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  pinIcon: {
    fontSize: '1.25rem',
    color: '#c0c6cb',
  },
}));

export default function Note({ handleCreate,handleDelete, handleUpdate, name, publishCtrl, id, pin, handlePin, type,rowIndex }) {
  const classes = useStyles(type);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const draftOnly=id<0;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [dialog, setdialog] = useState(false);

  const handleConfirm = () => {
    handleDelete(id,rowIndex);
    setdialog(false);
    setAnchorEl(false);
  };

  const [edit, setEdit] = useState(draftOnly);

  function dropContrl() {
    return publishCtrl ? (
      <div>
        <IconButton className={classes.button} onClick={handleClick} id={`DutyAssign-IconButton-ade-${id}`}>
          <MoreIcon className={classes.icon} />
        </IconButton>
        <Menu
          className={classes.menu}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          id="DutyAssign-Menu-adf"
          keepMounted
        >
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              setEdit(true);
              setAnchorEl(null);
            }}
            id={`DutyAssign-MenuItem-adg-${id}`}
          >
            <RemarksIcon className={classes.menuitemIcon} />
            <div className={classes.menuitemText}>{i18n.t('STAFF_TEMPORARY_EDIT')}</div>
          </MenuItem>
          {pin ? (
            <MenuItem
              className={classes.menuitem}
              style={{ borderTop: '0.0625rem solid #e4e7eb' }}
              onClick={() => {
                handlePin(id, 0);
                setAnchorEl(null);
              }}
              id={`DutyAssign-MenuItem-adh-${id}`}
            >
              <UnPinIcon className={classes.menuitemIcon} />
              <div className={classes.menuitemText}>{i18n.t('DUTYASSIGN_UNPIN_FOOTNOTE')}</div>
            </MenuItem>
          ) : (
            (!draftOnly)&&<MenuItem
              className={classes.menuitem}
              style={{ borderTop: '0.0625rem solid #e4e7eb' }}
              onClick={() => {
                handlePin(id, 1);
                setAnchorEl(null);
              }}
              id={`DutyAssign-MenuItem-adi-${id}`}
            >
              <PinBorderIcon className={classes.menuitemIcon} />
              <div className={classes.menuitemText}>{i18n.t('DUTYASSIGN_PIN_FOOTNOTE')}</div>
            </MenuItem>
          )}
          <MenuItem
            className={classes.menuitem}
            style={{ borderTop: '0.0625rem solid #e4e7eb' }}
            onClick={() => {
              setdialog(true);
            }}
            id={`DutyAssign-MenuItem-adj-${id}`}
          >
            <DeleteIcon className={classes.menuitemIcon} />
            <div className={classes.menuitemText}>{i18n.t('STAFF_TEMPORARY_DELETE')}</div>
          </MenuItem>
        </Menu>
        <Dialog
          open={dialog}
          handleClose={() => {
            setdialog(false);
          }}
          handleCancel={() => {
            setdialog(false);
          }}
          title={i18n.t('DUTYASSIGN_FOOTNOTE_DELETE_TITLE')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          cancelID="DutyAssign-Dialog-adk-cancel"
          confirmID="DutyAssign-Dialog-adk-confirm"
          closeID="DutyAssign-Dialog-adk-close"
          handleConfirm={handleConfirm}
        >
          <div className={classes.dialogText}>{i18n.t('DUTYASSIGN_FOOTNOTE_DELETE_BODY')}</div>
        </Dialog>
      </div>
    ) : null;
  }
  const draftStyle={
    borderColor: "orange"
    ,borderStyle: "solid"
    ,borderWidth: "1px"
  }

  return (
    <div  >
      {(edit) ? (
        <Edit text={name} edit={true} setEdit={setEdit} handleAdd={handleCreate} handleUpdate={handleUpdate} id={id} rowIndex={rowIndex} type={type} />
      ) : (
        <div className={classes.root} style={id<0?draftStyle:null} >
          <div style={{ display: 'flex', width: '80%' }}>
            {pin && (
              <div
                className={classes.pinIconBody}
                onClick={() => {
                  handlePin(id, 0);
                }}
                id={`DutyAssign-div-adl-${id}`}
                tabIndex={0}
                onKeyUp={(e) => onKeyUpEnterOrSpace(e, () => {
                  handlePin(id, 0);
                })}
              >
                <PinIcon className={classes.pinIcon} />
              </div>
            )}
            <div className={classes.text}>{name}</div>
          </div>
          {dropContrl()}
        </div>
      )}
    </div>
  );
}
